import { Link, Navigate, useParams } from 'react-router-dom';
import { RoomBackdrop } from '../components/RoomBackdrop';
import { getEngagement } from '../data/engagements';
import './WorkPages.css';

export function WorkEngagementPage() {
  const { engagementId } = useParams();
  const engagement = engagementId ? getEngagement(engagementId) : undefined;

  if (!engagement) {
    return <Navigate to="/work" replace />;
  }

  return (
    <>
      <RoomBackdrop room="work" dim={0} fit="contain" />
      <main className="page work-detail">
        <article className="work-detail__panel">
          <Link to="/work" className="work-detail__back">
            ← Engagements
          </Link>

          <h1 className="work-detail__title">{engagement.title}</h1>
          <p className="work-detail__lede">{engagement.lede}</p>

          <ul className="work-detail__facts" aria-label="Engagement facts">
            <li>
              <span className="work-detail__fact-label">Size</span>
              {engagement.companySize}
            </li>
            <li>
              <span className="work-detail__fact-label">Sector</span>
              {engagement.sector}
            </li>
            <li>
              <span className="work-detail__fact-label">Duration</span>
              {engagement.duration}
            </li>
            <li>
              <span className="work-detail__fact-label">Team</span>
              {engagement.consultants} consultants
            </li>
          </ul>

          <section className="work-detail__section">
            <h2>Situation</h2>
            <p>{engagement.situation}</p>
          </section>

          <section className="work-detail__section">
            <h2>How the engagement moved it forward</h2>
            <ul>
              {engagement.howForward.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="work-detail__section">
            <h2>Team on the ground</h2>
            <p>{engagement.teamLine}</p>
          </section>

          <section className="work-detail__section">
            <h2>Outcomes</h2>
            <ul>
              {engagement.outcomes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <Link to="/contact" className="work-detail__cta">
            Discuss a similar engagement
          </Link>
        </article>
      </main>
    </>
  );
}
